import React from "react";
import { Container,Box, Typography, Button,Card } from "@mui/material";
import background from "../../assets/background.jpg";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/Logo.svg";


function Thank() {
  return (

    <Container 
    maxWidth="2xl"
    sx={{
        height: '100vh', // Ensures full viewport height
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start', // Align items to the top
        paddingTop: '100px',
        paddingBottom: '100px',
        background: `url('${background}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center', // Center the background image
        overflow: 'auto', // Allow overflow for scrolling
    }}>

<Card
        sx={{
            position: 'relative',
            maxWidth: '500px',
            width:'97%',
            height:   'fit-content',
            margin: 0,
            backgroundColor: 'aliceblue',
            boxShadow: '0 0 15px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.7s ease-in-out',
            // overflow: active  ? 'hidden' :'auto',
            zIndex: 1,
            textAlign:'center',
        }}
        >

          <Box
              sx={{
                width: '100%',
                height: '150px',
                // background: `url('${background}')`,
                background: '#01081D',
                backgroundSize: 'cover',
                borderBottom: '1px solid lightgrey',
                transition: 'all 0.7s ease-in-out',
                display: 'flex',
                justifyContent: 'center',
                paddingTop:'20px'
              }}
            >
              <img src={Logo} alt="stat-icon" width={240} />
            </Box>

          <Box className="wrapper-2" sx={{padding:'40px '}}>
            <Typography
              variant="h1"
              gutterBottom
              sx={{
                fontSize: { xs: "4em", sm: "4em" },
                fontFamily: "'Kaushan Script', cursive",
                letterSpacing: "3px",
                color: "#4DC369",
                margin: 0,
                paddingTop:'10px',
                mb: 2,
              }}
            >
              Thank you!
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "1.2em",
                color: "#aaa",
                // fontFamily: "'Source Sans Pro', sans-serif",
                letterSpacing: "1px",
                padding:"15px 0px",
                m: 0,
              }}
            >
              Your Email Has Been Successfully Submited.
            </Typography>
            <Button
            component= {NavLink}
            to={"/contact-card"}
              className="go-home"
              variant="contained"
              color="primary"
              sx={{
                color: "#fff",
                bgcolor: "#4DC369",
                padding: "10px 50px",
                mt: 3,
                mb: { xs: 2, sm: 3 },
                borderRadius: "30px",
                textTransform: "capitalize",
                boxShadow: "0 10px 16px 1px rgba(174, 199, 251, 1)",
                "&:hover": { bgcolor: "#4a79d8" },
              }}
            >
              Go Home
            </Button>
          </Box>
        </Card>
    </Container>


  );
}

export default Thank;
